module.exports = __webpack_public_path__ + "static/media/Product_OnSiteService.6188ca9b.png";